import React, { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";
const AuthCtx = createContext(null);
export const useAuth = () => useContext(AuthCtx);
export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const refresh = async () => {
    const t = localStorage.getItem("vsq_token");
    if (!t) { setUser(null); setLoading(false); return null; }
    try {
      const { data } = await api.get("/auth/me");
      setUser(data); setLoading(false); return data;
    } catch {
      localStorage.removeItem("vsq_token"); setUser(null); setLoading(false); return null;
    }
  };
  useEffect(() => { refresh(); }, []);
  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    localStorage.setItem("vsq_token", data.token);
    setUser(data.user); await refresh();
  };
  const register = async (payload) => {
    const { data } = await api.post("/auth/register", payload);
    localStorage.setItem("vsq_token", data.token);
    setUser(data.user); await refresh();
  };
  const logout = () => { localStorage.removeItem("vsq_token"); setUser(null); };
  return <AuthCtx.Provider value={{ user, loading, login, register, logout, refresh }}>{children}</AuthCtx.Provider>;
}
